

<div >
  <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
    <div class="col-md-4 d-flex align-items-center">
      <span> &nbsp;&nbsp;&nbsp;&nbsp;  </span>
      <a href="/" class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
        <img src="../../assets/images/landing/techspot_200x200.png" width="30" height="30" alt="GeoAstra Logo">
      </a>
      <span class="mb-3 mb-md-0 text-body-secondary">&copy; 2025 GeoAstra - by Canada GPS</span>
    </div>

  </footer>
</div>